let adminBase = window._env_.VUE_APP_ADMIN_HOST



export const getMapCommentFeedbackTable = params => {
  return axios.post(`${adminBase}/query_market_map_comments`, params)
}



// WEBPACK FOOTER //
// ./src/views/map-comment-feedback/map-comment-feedback.api.js